import { clearErrors } from '@/reducers/auth';
import { AppDispatch } from '@/root/store';
import { FormatCurrency } from '@/routes/root';
import { ShowProfile } from '@/services/profile';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { DashboardCard } from '../../dashboard/_card';
import { SectionItem, SectionTabs } from '../../_nav/section';

export function OrgSettingCommerceLayout() {
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();

  const pathArray = location.pathname.split('/').slice(2);
  const section = pathArray[1];

  const [formData, setFormData] = useState({
    amount: 0,
    type: '',
    assigned_type: '',
  });

  const { profile, errors } = useSelector((state: any) => state.profile);

  const setData = (value: string, element: string) => {
    setFormData({ ...formData, [element]: value });

    dispatch(clearErrors());
  };

  useEffect(() => {
    if (profile) {
      setFormData({
        ...formData,
        type: profile.settings?.event?.fees?.type,
        assigned_type: profile.settings?.event?.fees?.assigned_type,
        amount: profile.settings?.event?.fees?.amount,
      });
    }
  }, [profile]);

  useEffect(() => {
    dispatch(ShowProfile());
  }, []);

  const sections: Record<string, string> = {
    providers: 'Penyedia Pembayaran',
    withdraws: 'Penarikan',
  };

  return !section ? (
    <Navigate to='providers' />
  ) : (
    <>
      <div className='flex gap-6'>
        <DashboardCard
          variant='whiteAlt'
          name='Biaya Admin'
          topLabel={{
            primary:
              formData.type === 'nominal' ? (
                <FormatCurrency amount={formData.amount} />
              ) : (
                `${formData.amount}%`
              ),
            secondary: 'per tiket',
          }}
          className='w-[268px]'
        />
      </div>
      <SectionTabs grow={false}>
        {Object.entries(sections).map(([key, value]) => {
          return (
            <SectionItem
              id={key}
              key={key}
              name={value}
              isCurrent={section === key}
            />
          );
        })}
      </SectionTabs>
      <Outlet />
    </>
  );
}
